module.exports = __webpack_public_path__ + "img/point-pro-1.4283a751.png";